import { atom } from '@exodus/headless-ui';
import ms from 'ms';
const DEFAULT_CONFIG = {
    defaultFromAsset: 'bitcoin',
    defaultToAsset: 'ethereum',
    defaultPollIntervalMs: ms('30s'),
    stalePollIntervalMs: ms('5s'),
    expiryMarginMs: ms('2s'),
};
const baseConfigAtom = atom(DEFAULT_CONFIG);
const configAtom = atom((get) => get(baseConfigAtom), (_get, set, newValue = {}) => {
    set(baseConfigAtom, { ...DEFAULT_CONFIG, ...newValue });
});
export default configAtom;
